import { render, staticRenderFns } from "./NoticeSend.vue?vue&type=template&id=1fbfc444&"
import script from "./NoticeSend.vue?vue&type=script&lang=js&"
export * from "./NoticeSend.vue?vue&type=script&lang=js&"
import style0 from "./NoticeSend.vue?vue&type=style&index=0&id=1fbfc444&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports